import * as React from 'react';

import { QuestionTypes } from '@showbie-socrative/socrative-utils';

import { translate } from '~l10n/client';
import { SmallButton } from '~shared/components/buttons';
import { IconAI } from '~shared/components/icons/standard';
import {
  TeacherApplicationContext,
  useTeacherApplicationContext,
} from '~shared/context/TeacherApplicationContext';

interface Props {
  quizQuestionLength: number;
  isDisabled: boolean;
  insertQuestion: (questionType: QuestionTypes, position: number) => void;
  openGenerateQuestionDialog: (position: number) => void;
  openExtractQuestionsDialog: (position: number) => void;
  openImportByTextDialog: (position: number) => void;
}

export default QuizEditorAddQuestion;

export function QuizEditorAddQuestion({
  quizQuestionLength,
  insertQuestion,
  openGenerateQuestionDialog,
  openExtractQuestionsDialog,
  openImportByTextDialog,
  isDisabled,
}: Props) {
  const teacherApplicationContext = useTeacherApplicationContext();
  return (
    <div
      className="py-12"
      style={{ boxShadow: '0px 1px 0px 0px #E7EDF0 inset' }}
    >
      <div className="grid lg:grid-cols-add-new-question-wide grid-cols-1 grid-rows-none lg:grid-flow-col gap-4 justify-items-center">
        <div>
          <span className="text-display font-display font-700 leading-8 text-blue-900">
            {translate('Add Blank Question')}
          </span>
        </div>
        <div className="flex flex-col gap-3 items-center">
          <SmallButton
            isDisabled={isDisabled}
            className="whitespace-no-wrap"
            onClick={() =>
              insertQuestion(
                QuestionTypes.MultipleChoice,
                quizQuestionLength + 1
              )
            }
          >
            {translate('Multiple Choice')}
          </SmallButton>
          <SmallButton
            className="whitespace-no-wrap"
            isDisabled={isDisabled}
            onClick={() =>
              insertQuestion(QuestionTypes.TrueFalse, quizQuestionLength + 1)
            }
          >
            {translate('True / False')}
          </SmallButton>
          <SmallButton
            className="whitespace-no-wrap"
            isDisabled={isDisabled}
            onClick={() =>
              insertQuestion(QuestionTypes.FreeResponse, quizQuestionLength + 1)
            }
          >
            {translate('Short Answer')}
          </SmallButton>
        </div>
        <div className="row-span-2 ">
          <div
            className="bg-grey-200 h-full lg:visible invisible"
            style={{ width: '1px' }}
          ></div>
        </div>
        <div className="flex content-center">
          <span className="text-display font-display font-700 leading-8 text-blue-900">
            {translate('AI Assisted')}
          </span>
          <IconAI className="text-orange-600" />
        </div>
        <div className="flex flex-col gap-3 items-center">
          <SmallButton
            className="whitespace-no-wrap"
            appearance="primary"
            isDisabled={isDisabled}
            onClick={() => openGenerateQuestionDialog(quizQuestionLength + 1)}
          >
            {translate('Generate Questions')}
          </SmallButton>
          {__DEV__ ||
          teacherApplicationContext ===
            TeacherApplicationContext.ShowbieAssessments ? (
            <SmallButton
              className="whitespace-no-wrap"
              appearance="primary"
              isDisabled={isDisabled}
              onClick={() => openExtractQuestionsDialog(quizQuestionLength + 1)}
            >
              {translate('Extract Questions from Document')}
            </SmallButton>
          ) : null}
          <SmallButton
            appearance="primary"
            className="whitespace-no-wrap"
            isDisabled={isDisabled}
            onClick={() => openImportByTextDialog(quizQuestionLength + 1)}
          >
            {translate('Copy-Paste Questions')}
          </SmallButton>
        </div>
      </div>
    </div>
  );
}
